import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Tooltip, Alert, Typography } from "@mui/material";
import * as wjGrid from "@grapecity/wijmo.react.grid";
import * as wjCore from "@grapecity/wijmo";
import { useEffect, useRef, useState } from "react";
import { FlexGridFilter } from "@grapecity/wijmo.react.grid.filter";
import './careUnitSelectionDialog.css';
import { Warning } from "@mui/icons-material";

const CareUnitSelectionDialog = ({
    open,
    apartments,
    tempSelected,
    setTempSelected,
    onConfirm,
    onClose,
    childGender,
    childAge
}) => {
    const gridRef = useRef(null)
    const [selectedApartment, setSelectedApartment] = useState(null);



    const formatCharacteristics = (cc) => {
        if (!cc || cc.length === 0) return "-";
        return cc.map((c) => `${c.gender} (${c.age})`).join(", ");
    };

    useEffect(() => {
        if (!open) setSelectedApartment(null);
    }, [open]);

    const toggleApartmentSelection = (apartment) => {
        const nextSelection = selectedApartment?.id === apartment.id
            ? null
            : apartment;
        setSelectedApartment(nextSelection);

        if (gridRef.current) {
            gridRef.current.selectedApartment = nextSelection;
        }
    };



    return (
        <Dialog
            open={open}
            disableScrollLock

            maxWidth="xl"
            fullWidth
            onClose={onClose}
            disableEnforceFocus
            disableAutoFocus   // optional but often helps
        >
            <DialogTitle variant='h4'>Επιλογή ΜΠΠΦ για {childGender} - {childAge} ετών</DialogTitle>

            <DialogContent dividers sx={{ height: 600, p: 2 }}>{
                apartments?.length > 0 ?
                    <wjGrid.FlexGrid
                        frozenColumns={2}
                        itemsSource={apartments}
                        isReadOnly={true}
                        selectionMode="None"
                        headersVisibility="Column"
                        className="apartment-selection-grid"
                        maxHeight="95%"
                        style={{ maxHight: '95%' }}

                        initialized={(grid) => {
                            gridRef.current = grid;
                        }}
                        formatItem={(s, e) => {
                            const item = s.rows[e.row]?.dataItem;



                            // ROW HIGHLIGHT
                            if (e.panel === s.cells) {
                                if (tempSelected?.id === item?.id) {
                                    e.cell.style.backgroundColor = "#e3f2fd";
                                }
                            }
                        }}
                    >
                        <wjGrid.FlexGridColumn header="" width={50} align="center">
                            <wjGrid.FlexGridCellTemplate cellType="Cell" template={({ item }) => (
                                <input
                                    type="checkbox"
                                    aria-label={`Επιλογή ${item.name}`}
                                    checked={selectedApartment?.id === item.id}
                                    onChange={() => toggleApartmentSelection(item)}
                                    onMouseDownCapture={(event) => event.stopPropagation()}
                                    onClick={(event) => event.stopPropagation()}
                                />
                            )} />
                        </wjGrid.FlexGridColumn>
                        <wjGrid.FlexGridColumn binding="name" header="Όνομα" width={360}>
                            <wjGrid.FlexGridCellTemplate cellType='Cell' template={(ctx) => {
                                const item = ctx.item;
                                return (<>
                                    {/* {!item.hasActiveUsers &&
                                        <Tooltip title='Η ΜΗΔ δεν διαθέτει ενεργό προσωπικό!'>
                                            <Warning color='warning' fontSize='small' sx={{ mr: 1 }} />
                                        </Tooltip>} */}
                                    <span>{item.name}</span>
                                </>)
                            }} />
                        </wjGrid.FlexGridColumn>
                        <wjGrid.FlexGridColumn binding="type" header="Τύπος" width={320} />
                        <wjGrid.FlexGridColumn binding="category" header="Είδος" width={200} />


                        <wjGrid.FlexGridColumn binding="municipality" header="Δήμος" width={400} />
                        <wjGrid.FlexGridColumn binding="prefecture" header="Περιφερειακή Ενότητα" width={400} />

                        <FlexGridFilter />

                    </wjGrid.FlexGrid> :
                    <Typography align='center' mt={2} mb={2} variant='h4'>Δεν βρέθηκαν διαθέσιμες μονάδες παιδικής προστασίας και φροντίδας!</Typography>}

            </DialogContent >

            <DialogActions>

                <Button onClick={onClose}>Κλείσιμο</Button>
                <Button variant="contained" onClick={() => onConfirm(selectedApartment)} disabled={!!!selectedApartment}>
                    Επιλογή
                </Button>
            </DialogActions>
        </Dialog >
    );
};

export default CareUnitSelectionDialog;
